import { ColDef } from 'ag-grid-community';
import { useMemo } from 'react';
import { AgTable } from '../../../../../components/AgTable/AgTable';
import { customAggFuncs } from '../columns/AggregationConfigs';
import { DrillDownColId } from '../columns/PredefinedColumns/DrillDown/DrillDown';
import { IRoundsModalContentsProps } from './RoundsModalContents';

export function SimplifiedOverviewGrid(props: IRoundsModalContentsProps) {
  const { mainGridColDef, mainRowData } = props;
  const mainColDefSimplified = mainGridColDef.reduce((acc, colDef) => {
    const cellRendererParams = { ...colDef.cellRendererParams };
    if (colDef.colId !== DrillDownColId) {
      acc.push({
        ...colDef,
        cellRendererParams,
        rowGroup: false,
        sortable: false,
        suppressHeaderMenuButton: true,
        suppressMovable: true,
      });
    }

    return acc;
  }, [] as ColDef[]);

  const aggFuncs = useMemo(() => {
    return { ...customAggFuncs };
  }, []);

  return (
    <AgTable
      aggFuncs={aggFuncs}
      columnDefs={mainColDefSimplified}
      groupDefaultExpanded={-1}
      onGridReady={(event) => {
        event.api.autoSizeColumns(event.api.getColumns() ?? []);
      }}
      rowData={[mainRowData]}
      rowGroupPanelShow='never'
      suppressMovableColumns={true}
      suppressRowDrag={true}
    />
  );
}
